export default __webpack_public_path__ + "static/coop-1a7c15f98e4fb660392cd472b601c0fa.png";